







import { Component } from 'vue-property-decorator';
import AbstractDisplayField from './abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-birthdate',
  components: {},
})
export default class DisplayFieldBirthdate extends mixins(AbstractDisplayField) {
  get formatDate(): string {
    if (this.value) {
      return moment(String(this.value)).format('DD/MM/YYYY');
    }
    return '';
  }
  get age(): string {
    if (this.value) {
      const age = moment().diff(String(this.value), 'years');
      const suffix = age == 1 ? this.$t('global.year_old') : this.$t('global.years_old');
      return age + ' ' + suffix;
    }
    return '';
  }
}
